export default __webpack_public_path__ + "static/media/12.77ad8861.jpg";